import Button from "@mui/material/Button";
import { FeatureFlagKey } from "encamp-shared/src/featureFlags";
import { useCurrentUser } from "hooks/useCurrentUser";
import { useFeatureFlags } from "hooks/useFeatureFlags";
import { useLocalStorageState } from "hooks/useLocalStorageState";

export const VENDOR_DASHBOARD_STORAGE_KEY = "waste-manifests-vendor-dashboard-open";

export function VendorDashboardToggle() {
  const { isStaff } = useCurrentUser();
  const { featureFlags } = useFeatureFlags();
  const enabled = isStaff && featureFlags[FeatureFlagKey.WasteEpaCorrectionDiscrepancies];

  const [open, setOpen] = useLocalStorageState<boolean>(VENDOR_DASHBOARD_STORAGE_KEY, {
    defaultValue: true,
  });

  if (!enabled) {
    return null;
  }

  return (
    <Button onClick={() => setOpen(!open)} variant="text">
      {open ? "Hide Vendor Stats" : "Show Vendor Stats"}
    </Button>
  );
}
